import React, { useEffect } from "react";
import "./Toast.css";

const iconMap = {
  add: "fas fa-check-circle",
  edit: "fas fa-pen",
  delete: "fas fa-trash-alt",
};

const colorMap = {
  add: "#2fd67a",
  edit: "#5529dc",
  delete: "#ff3b4b",
};

const labelMap = {
  add: "Task Added!",
  edit: "Task Updated!",
  delete: "Task Deleted!",
};

const Toast = ({ toasts, removeToast }) => {
  return (
    <div className="toast-container">
      {toasts.map((toast) => (
        <ToastItem
          key={toast.id}
          toast={toast}
          removeToast={removeToast}
          icon={iconMap[toast.type]}
          color={colorMap[toast.type]}
          label={labelMap[toast.type]}
        />
      ))}
    </div>
  );
};

const ToastItem = ({ toast, removeToast, icon, color, label }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      removeToast(toast.id);
    }, 3000);
    return () => clearTimeout(timer);
  }, [toast.id, removeToast]);

  return (
    <div className="toast-item" style={{ "--toast-color": color }}>
      <div className="toast-icon">
        <i className={icon}></i>
      </div>
      <div className="toast-content">
        <p className="toast-label">{label}</p>
        <p className="toast-message">{toast.message}</p>
      </div>
      <button className="toast-close" onClick={() => removeToast(toast.id)}>
        <i className="fas fa-times"></i>
      </button>
      <div className="toast-progress" style={{ animationDuration: "3000ms" }}></div>
    </div>
  );
};

export default Toast;
